var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable max-lines */
import React, { Component } from 'react';
import Immutable from 'immutable';
import { Tabs, TabLink, TabContent } from 'react-tabs-redux';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { Icon } from "../../UI";
import { withContext, withRouter } from "../../componentWrappers";
import { AttachmentsList } from "../../Attachments";
import { ConnectionsGroups, ConnectionsList, ResetSearch } from "../../ConnectionsList";
import { CreateConnectionPanel, actions as connectionsActions } from "../../Connections";
import { MetadataFormButtons, ShowMetadata } from "../../Metadata";
import { RelationshipsFormButtons } from "../../Relationships";
import { TemplateLabel, Icon as PropertyIcon } from "../../Layout";
import { connectionsChanged, deleteConnection } from "../../ConnectionsList/actions/actions";
import { t, I18NLink } from "../../I18N";
import AddEntitiesPanel from "../../Relationships/components/AddEntities";
import RelationshipMetadata from "../../Relationships/components/RelationshipMetadata";
import ShowIf from "../../App/ShowIf";
import SidePanel from "../../Layout/SidePanel";
import ContextMenu from "../../ContextMenu";
import { FileList } from "../../Attachments/components/FileList";
import { CopyFromEntity } from "../../Metadata/components/CopyFromEntity";
import { PageViewer } from "../../Pages/components/PageViewer";

import { ShowSidepanelMenu } from "./ShowSidepanelMenu";
import V2NewRelationshipsBoard from "./V2NewRelationshipsBoard";
import { deleteEntity } from "../actions/actions";
import { showTab } from "../actions/uiActions";
import EntityForm from "../containers/EntityForm";

class EntityViewer extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      panelOpen: !this.props.hasPageView,
      copyFrom: false,
      copyFromProps: []
    };
    this.deleteEntity = this.deleteEntity.bind(this);
    this.closePanel = this.closePanel.bind(this);
    this.openPanel = this.openPanel.bind(this);
    this.toggleCopyFrom = this.toggleCopyFrom.bind(this);
    this.onCopyFromSelect = this.onCopyFromSelect.bind(this);
    this.deleteConnection = this.deleteConnection.bind(this);
  }

  componentDidMount() {
    const { params, hasPageView } = this.props;
    if (hasPageView && !params.tabView) {
      this.props.showTab('page');
    } else {
      this.props.showTab(params.tabView);
    }
  }

  onCopyFromSelect(copyFromProps) {
    this.setState({ copyFromProps });
  }

  deleteEntity() {
    this.props.mainContext.confirm({
      accept: () => {
        this.props.deleteEntity(this.props.entity.toJS()).then(() => {
          this.props.navigate(-1);
        });
      },
      title: 'Confirm delete',
      message: 'Are you sure you want to delete this entity?'
    });
  }

  toggleCopyFrom() {
    this.setState((currentState) => ({
      copyFrom: !currentState.copyFrom
    }));
  }

  deleteConnection(reference) {
    if (reference.sourceType !== 'metadata') {
      this.props.mainContext.confirm({
        accept: () => {
          this.props.deleteConnection(reference);
        },
        title: 'Confirm delete connection',
        message: 'Are you sure you want to delete this connection?'
      });
    }
  }

  closePanel() {
    this.setState({ panelOpen: false });
  }

  openPanel() {
    this.setState({ panelOpen: true });
  }

  linkClassNames(tabsToSelect) {
    const { tab: selectedTab } = this.props;
    return `${tabsToSelect.includes(selectedTab) ? 'selected' : ''} entity-sidepanel-tab-link`;
  }

  render() {
    const {
      entity,
      entityBeingEdited,
      tab: selectedTab,
      connectionsGroups,
      relationships,
      hasPageView,
      user,
      formState
    } = this.props;

    const { panelOpen, copyFrom, copyFromProps } = this.state;
    const rawEntity = entity.toJS();
    const summary = connectionsGroups.reduce(
      (summaryData, g) => {
        g.get('templates').forEach((template) => {
          summaryData.totalConnections += template.get('count');
        });
        return summaryData;
      },
      { totalConnections: 0 }
    );

    const includeFooter = user.get('_id') && ['info', 'relationships'].includes(selectedTab);
    const hasHeader = ['info', 'relationships'].includes(selectedTab);
    const mainClass = `entity-viewer ${hasHeader ? 'with-header' : ''} ${
    user.get('_id') && includeFooter ? 'with-footer' : ''
    } ${panelOpen ? 'with-panel' : ''}`;

    return /*#__PURE__*/(
      _jsx("div", { className: "row" }, void 0, /*#__PURE__*/
      _jsx(Helmet, {}, void 0, /*#__PURE__*/
      _jsx("title", {}, void 0, entity.get('title') ? entity.get('title') : 'Entity')
      ),

      selectedTab !== 'page' && /*#__PURE__*/
      _jsx("div", { className: "content-header content-header-entity" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "content-header-title" }, void 0, /*#__PURE__*/
      _jsx(PropertyIcon, {
        className: "item-icon item-icon-center",
        data: entity.get('icon'),
        size: "sm" }
      ), /*#__PURE__*/
      _jsx("h1", { className: "item-name" }, void 0, entity.get('title')), /*#__PURE__*/
      _jsx(TemplateLabel, { template: entity.get('template') })
      )
      ), /*#__PURE__*/


      _jsx("main", { className: mainClass }, void 0, /*#__PURE__*/
      _jsx(Tabs, { selectedTab: selectedTab }, void 0,
      hasPageView && /*#__PURE__*/
      _jsx(TabContent, { for: "page" }, void 0, /*#__PURE__*/
      _jsx(PageViewer, { setBrowserTitle: false })
      ), /*#__PURE__*/

      _jsx(TabContent, {
        for: selectedTab === 'info' || selectedTab === 'attachments' ? selectedTab : 'none' }, void 0, /*#__PURE__*/

      _jsx("div", { className: "entity-metadata" }, void 0,
      (() => {
        if (entityBeingEdited) {
          return /*#__PURE__*/_jsx(EntityForm, { highlightedProps: copyFromProps });
        }
        return /*#__PURE__*/(
          _jsx("div", {}, void 0, /*#__PURE__*/
          _jsx(ShowMetadata, {
            relationships: relationships,
            entity: rawEntity,
            showTitle: false,
            showType: false,
            groupGeolocations: true }
          ), /*#__PURE__*/
          _jsx(FileList, { files: rawEntity.documents, entity: rawEntity }), /*#__PURE__*/
          _jsx(AttachmentsList, {
            attachments: rawEntity.attachments,
            parentId: entity.get('_id'),
            parentSharedId: entity.get('sharedId'),
            entityView: true,
            processed: entity.get('processed') }
          )
          ));

      })()
      )
      ), /*#__PURE__*/
      _jsx(TabContent, { for: "relationships" }, void 0, /*#__PURE__*/
      _jsx(ConnectionsList, { deleteConnection: this.deleteConnection, searchCentered: true })
      ),
      this.props.newRelationshipsEnabled && /*#__PURE__*/
      _jsx(TabContent, { for: "newrelationships" }, void 0, /*#__PURE__*/
      _jsx(V2NewRelationshipsBoard, { sharedId: entity.get('sharedId') })
      )

      )
      ),

      user.get('_id') && /*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx(ShowIf, { if: selectedTab === 'info' || selectedTab === 'attachments' }, void 0, /*#__PURE__*/
      _jsx("div", { className: `entity-footer ${panelOpen ? 'with-sidepanel' : ''}` }, void 0, /*#__PURE__*/
      _jsx(MetadataFormButtons, {
        includeViewButton: false,
        delete: this.deleteEntity,
        data: this.props.entity,
        formStatePath: "entityView.entityForm",
        formState: formState,
        entityBeingEdited: entityBeingEdited,
        copyFrom: this.toggleCopyFrom }
      )
      )
      ), /*#__PURE__*/

      _jsx(ShowIf, { if: selectedTab === 'relationships' }, void 0, /*#__PURE__*/
      _jsx("div", { className: `entity-footer ${panelOpen ? 'with-sidepanel' : ''}` }, void 0, /*#__PURE__*/
      _jsx(RelationshipsFormButtons, {})
      )
      )
      ), /*#__PURE__*/


      _jsx(SidePanel, { className: `entity-relationships entity-${selectedTab}`, open: panelOpen }, void 0, /*#__PURE__*/
      _jsx("div", { className: "sidepanel-header" }, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: "closeSidepanel close-modal",
        onClick: this.closePanel.bind(this),
        "aria-label": "Close side panel" }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "times" })
      ), /*#__PURE__*/
      _jsx(Tabs, {
        className: "content-header-tabs",
        selectedTab: selectedTab,
        handleSelect: (tabName) => {
          this.props.showTab(tabName);
        } }, void 0, /*#__PURE__*/

      _jsx("ul", { className: "nav nav-tabs" }, void 0,
      hasPageView && /*#__PURE__*/
      _jsx("li", {}, void 0, /*#__PURE__*/
      _jsx(TabLink, {
        to: "page",
        role: "button",
        tabIndex: "0",
        "aria-label": t('System', 'Page', null, false),
        component: "div" }, void 0, /*#__PURE__*/

      _jsx(I18NLink, {
        className: this.linkClassNames(['page']),
        to: `/entity/${rawEntity.sharedId}/page` }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "file-image" }), /*#__PURE__*/
      _jsx("span", { className: "tab-link-tooltip" }, void 0, t('System', 'Page'))
      )
      )
      ), /*#__PURE__*/

      _jsx("li", {}, void 0, /*#__PURE__*/
      _jsx(TabLink, {
        to: "info",
        role: "button",
        tabIndex: "0",
        "aria-label": t('System', 'Info', null, false),
        component: "div" }, void 0, /*#__PURE__*/

      _jsx(I18NLink, {
        className: this.linkClassNames(['info', '']),
        to: `/entity/${rawEntity.sharedId}/info` }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "info-circle" }), /*#__PURE__*/
      _jsx("span", { className: "tab-link-tooltip" }, void 0, t('System', 'Info'))
      )
      )
      ), /*#__PURE__*/
      _jsx("li", {}, void 0, /*#__PURE__*/
      _jsx(TabLink, {
        to: "relationships",
        role: "button",
        tabIndex: "0",
        "aria-label": t('System', 'Relationships', null, false),
        component: "div" }, void 0, /*#__PURE__*/

      _jsx(I18NLink, {
        className: this.linkClassNames(['relationships']),
        to: `/entity/${rawEntity.sharedId}/relationships` }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "exchange-alt" }), /*#__PURE__*/
      _jsx("span", { className: "connectionsNumber" }, void 0, summary.totalConnections), /*#__PURE__*/
      _jsx("span", { className: "tab-link-tooltip" }, void 0, t('System', 'Relationships'))
      )
      )
      ),
      this.props.newRelationshipsEnabled && /*#__PURE__*/
      _jsx("li", {}, void 0, /*#__PURE__*/
      _jsx(TabLink, {
        to: "newrelationships",
        role: "button",
        tabIndex: "0",
        "aria-label": "New Relationships",
        component: "div" }, void 0, /*#__PURE__*/

      _jsx(I18NLink, {
        className: this.linkClassNames(['newrelationships']),
        to: `/entity/${rawEntity.sharedId}/newrelationships` }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "exchange-alt" }), "*", /*#__PURE__*/
      _jsx("span", { className: "tab-link-tooltip", "no-translate": true }, void 0, "New Relationships"

      )
      )
      )
      )

      )
      )
      ), /*#__PURE__*/
      _jsx(ShowIf, { if: selectedTab === 'info' || selectedTab === 'relationships' }, void 0, /*#__PURE__*/
      _jsx("div", { className: "sidepanel-footer" }, void 0, /*#__PURE__*/
      _jsx(ResetSearch, {})
      )
      ), /*#__PURE__*/

      _jsx("div", { className: "sidepanel-body" }, void 0, /*#__PURE__*/
      _jsx(Tabs, { selectedTab: selectedTab }, void 0, /*#__PURE__*/
      _jsx(TabContent, {
        for: ['info', 'relationships', 'page'].includes(selectedTab) ? selectedTab : 'none' }, void 0, /*#__PURE__*/

      _jsx(ConnectionsGroups, {})
      )
      )
      )
      ), /*#__PURE__*/
      _jsx(SidePanel, { className: "copy-from-panel", open: copyFrom }, void 0, /*#__PURE__*/
      _jsx("div", { className: "sidepanel-body" }, void 0, /*#__PURE__*/
      _jsx(CopyFromEntity, {
        isVisible: copyFrom,
        originalEntity: this.props.entityState,
        templates: this.props.templates,
        onSelect: this.onCopyFromSelect,
        formModel: "entityView.entityForm",
        onCancel: this.toggleCopyFrom }
      )
      )
      ), /*#__PURE__*/

      _jsx(ContextMenu, {
        align: `bottom${includeFooter ? '-with-footer' : ''}`,
        overrideShow: true,
        show: !panelOpen,
        className: "show-info-sidepanel-context-menu" }, void 0, /*#__PURE__*/

      _jsx(ShowSidepanelMenu, {
        className: "show-info-sidepanel-menu",
        panelIsOpen: panelOpen,
        openPanel: this.openPanel }
      )
      ), /*#__PURE__*/

      _jsx(CreateConnectionPanel, {
        className: "entity-create-connection-panel",
        containerId: entity.sharedId,
        onCreate: this.props.connectionsChanged }
      ), /*#__PURE__*/
      _jsx(AddEntitiesPanel, {}), /*#__PURE__*/
      _jsx(RelationshipMetadata, {})
      ));

  }
}

EntityViewer.defaultProps = {
  relationships: Immutable.fromJS([]),
  entityBeingEdited: false,
  tab: 'info',
  hasPageView: false,
  user: Immutable.fromJS({}),
  locale: 'en',
  // v2
  newRelationshipsEnabled: false
};





























const selectRelationTypes = createSelector(
  (s) => s.relationTypes,
  (r) => r.toJS()
);

const mapStateToProps = (state) => {var _state$settings, _state$settings$colle, _state$settings$colle2;
  const entityTemplateId = state.entityView.entity && state.entityView.entity.get('template');
  const entityTemplate = state.templates.find((template) => template.get('_id') === entityTemplateId);
  const templateWithPageView = entityTemplate.get('entityViewPage');
  const defaultTab = templateWithPageView ? 'page' : 'info';
  const { uiState } = state.entityView;
  return {
    entity: state.entityView.entity,
    relationTypes: selectRelationTypes(state),
    templates: state.templates,
    relationships: state.entityView.entity.get('relations'),
    connectionsGroups: state.relationships.list.connectionsGroups,
    entityBeingEdited: !!state.entityView.entityForm._id,
    tab: uiState.get('userSelectedTab') ? uiState.get('tab') : defaultTab,
    hasPageView: Boolean(templateWithPageView),
    user: state.user,
    locale: state.locale,
    formState: state.entityView.entityFormState,
    entityState: state.entityView.entityForm,
    // Is this used at all?
    library: state.library,
    // relationships v2
    newRelationshipsEnabled: (_state$settings = state.settings) === null || _state$settings === void 0 ? void 0 : (_state$settings$colle = _state$settings.collection) === null || _state$settings$colle === void 0 ? void 0 : (_state$settings$colle2 = _state$settings$colle.get('features')) === null || _state$settings$colle2 === void 0 ? void 0 : _state$settings$colle2.get('newRelationships')
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      deleteEntity,
      connectionsChanged,
      deleteConnection,
      showTab,
      startNewConnection: connectionsActions.startNewConnection
    },
    dispatch
  );
}

export { EntityViewer, mapStateToProps };
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withContext(EntityViewer)));